import { createFileRoute } from '@tanstack/react-router';
import { TenantFeatureConfigForm } from '@/components/tenants/TenantFeatureConfigForm';

export const Route = createFileRoute('/dashboard/tenant/$tenantCode/features')({
  component: TenantFeaturesRoute,
});

function TenantFeaturesRoute() {
  const { tenantCode } = Route.useParams();

  return (
    <div className="space-y-4">
      <div className="text-sm text-muted-foreground">
        Configure feature flags for <span className="font-semibold">{tenantCode}</span>.
      </div>
      <TenantFeatureConfigForm tenantCode={tenantCode} />
    </div>
  );
}
